"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const englishTranslation = {
    cartListTitle: 'Shopping Cart',
    digitalListTitle: 'Immediately Available',
    itemLabel: 'item',
    itemsLabel: 'items',
    shippingTitle: 'Shipping',
    autoshipAllSubscribe: 'Subscribe',
    autoshipAllSave: 'Autoship products in your cart and save 5%!',
    autoshipFrequencyLabel: 'Frequency',
    autoshipSelectFrequency: 'Select Frequency',
    autoshipQuarterly: 'Quarterly',
    autoshipMonth: 'month',
    autoshipMonths: 'months',
    autoshipCancelEdit: 'Cancel Editing',
    autoshipEdit: 'edit',
    cartLoginMessageLoginText: 'Login',
    cartLoginMessageOrText: 'or',
    cartLoginMessageCreateAccountText: 'Create an Account',
    cartLoginMessageEndText: 'to keep your items saved. As a guest customer, items stay in your shopping cart for 30 days.',
    byLineLabel: 'by',
    itemNumberLabel: 'Item #',
    promotionAppliedLabel1: 'Promotion',
    promotionAppliedLabel2: 'applied',
    bundleItemsLabel: 'Items included in bundle',
    autoshipSetupLink: 'Set-up automatic orders for this product with',
    eachAbrevLabel: 'ea',
    wasText: 'was',
    quantityLabel: 'Quantity',
    removeItemLabel: 'Remove item from cart',
    itemRemovedText: 'was removed from your cart.',
    undoLinkText: 'undo',
    closeButtonLabel: 'Close',
    freeShipping: 'Free shipping eligible',
    ebook: 'eBook',
};
exports.default = englishTranslation;
